import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { END } from 'redux-saga';
import { Box } from 'rebass/styled-components';
import SEO from '../../components/molecules/Seo';
import { getSSRProtocolAndHost, talentNetworkRouteGuard } from '../../helpers/ssrHelpers';
import { wrapper } from '../../redux/store';
import { jobSeekerOnboardingStart } from '../../redux/actions/onboardingActions';
import { NetworkSchema } from '../../schema/network';
import { ProtocolSchema } from '../../schema/protocol';
import TalentOnboarding from '../../containers/talentOnboarding';

const OnboardingPage = ({ network, host, protocol }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(jobSeekerOnboardingStart({ vouched_user: false, network }));
  });

  return (
    <>
      <SEO network={network} title="Onboarding" host={host} protocol={protocol} />
      <TalentOnboarding network={network} />
    </>
  );
};

OnboardingPage.propTypes = {
  protocol: ProtocolSchema.isRequired,
  host: PropTypes.string.isRequired,
  network: NetworkSchema.isRequired,
};

// eslint-disable-next-line react/no-multi-comp, react/prop-types
OnboardingPage.Layout = ({ children }) => (
  <Box bg="neutral.0" sx={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, overflow: 'auto' }}>
    {children}
  </Box>
);

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
  const { req } = ctx;
  const { network } = req;
  const { protocol, host } = getSSRProtocolAndHost(ctx);
  const tnRedirect = talentNetworkRouteGuard(!network?.tnSettings?.tnHidden);

  store.dispatch(END);
  await store.sagaTask.toPromise();

  return tnRedirect || { props: { protocol, host } };
});

export default OnboardingPage;
